import { GestureResponderEvent } from 'react-native';

import { OrderDisplayType } from '@fhs/ui/src/components/order-display/types';
import { ILoyaltyQuestUi } from '@fhs-legacy/frontend/src/generated/graphql-gateway';

import { HomeAlertLaunchDarklyPayload } from './home-alert';

export type DisplayedOrder = {
  id: string;
  type: OrderDisplayType;
  storeName: string;
  serviceModeTitle: string;
  items: Array<{
    quantity: number;
    name: string;
    image: string;
  }>;
};

export type ScreenHomeProps = {
  //Boolean Values
  displayedOrderCardLoading?: boolean;
  isCateringEnabled: boolean;
  isDeliveryEnabled: boolean;
  isDesktop: boolean;
  isLoadingChallenges: boolean;
  loyaltyUserReady: boolean;
  reorderLoading?: boolean;
  shouldShowDelivery: boolean;
  //Homepage data
  alert: HomeAlertLaunchDarklyPayload | null;
  challengesData?: ILoyaltyQuestUi[];
  displayedOrder: null | DisplayedOrder;
  userPointExpireAlert: HomeAlertLaunchDarklyPayload | null;
  //Routes
  careersPath: string;
  cateringRedirectPath: string;
  deliveryRedirectPath: string;
  donatePath: string;
  foundationPath: string;
  pickUpRedirectPath: string;
  redirectPath: string;
  //Actions
  onDeliverySelect: (event: GestureResponderEvent) => void;
  onReorder: () => void;
  logReorderCardPress: () => void;
  logPickUpOrderClickEvent: (event: GestureResponderEvent) => void;
  logDeliveryOrderClickEvent: (event: GestureResponderEvent) => void;
  logCateringOrderClickEvent: (event: GestureResponderEvent) => void;
  onPressChallenge: (challenge: ILoyaltyQuestUi) => Promise<void>;
  showChallengeInfo: (challengeId: string) => void;
};
